<template>
  <div class="cangchu_rk">
    <div>
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            ref="search"
            style="display: flex"
            :model="searchForm"
            label-position="center"
            label-width="90px"
          >
            <el-form-item label="化学品:" style="">
              <el-input
                v-model="searchForm.hxpMc"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="仓库名称:">
              <el-select v-model="searchForm.ckId" filterable placeholder="请选择">
                <el-option
                  v-for="(item, i) in ckList"
                  :key="i"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="入库日期:">
              <el-col :span="10">
                <el-date-picker
                  v-model="searchForm.beginTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                />
              </el-col>
              <el-col
                style="text-align: center"
                class="line"
                :span="3"
              >-</el-col>
              <el-col :span="10">
                <el-date-picker
                  v-model="searchForm.endTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                />
              </el-col>
            </el-form-item>
            <el-form-item label="状态:" label-width="50px">
              <el-select v-model="searchForm.zt" placeholder="请选择">
                <el-option
                  v-for="(item, i) in ztList"
                  :key="i"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-button
              v-preventReClick
              class="sousuoButton"
              icon="el-icon-search"
              round
              size="small"
              type="primary"
              @click="handleCurrentChange(1)"
            >搜索</el-button>
            <el-button
              v-preventReClick
              class="resetbutton"
              icon="el-icon-refresh-right"
              @click="chongzhi"
            >重置</el-button>
          </el-form>
        </div>
      </div>
      <div
        style="
          margin: auto;
          width: 95%;
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 57px;
        "
      >
        <div class="tablemes">
          <el-table
            ref="ccrkTable"
            v-loading="loading"
            :data="tableData"
            border
            :cell-style="cellStyle"
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
            @select="select"
          >
            <el-table-column>
              <template slot="header">
                <el-button
                  v-preventReClick
                  type="primary"
                  class="addButton"
                  size="mini"
                  icon="el-icon-plus"
                  style="border: none"
                  @click="addPupShow"
                >新增</el-button>
                <el-button
                  v-preventReClick
                  size="mini"
                  icon="el-icon-plus"
                  @click="fuzhi"
                >复制新增</el-button>
                <el-button
                  v-preventReClick
                  icon="el-icon-upload2"
                  size="mini"
                  @click="daochu"
                >导出</el-button>
              </template>
              <el-table-column
                align="center"
                type="selection"
                width="55"
              />

              <el-table-column
                v-for="(item, i) in table"
                :key="i"
                :show-overflow-tooltip="true"
                align="center"
                :prop="item.key"
                :label="item.label"
                :width="item.key == 'rkbh' ? '180' : ''"
              >
                <template slot-scope="scope">
                  <span
                    v-if="item.label == '变更次数'"
                    style="cursor: pointer"
                    :title="scope.row[item.key]"
                    @click="bgcsClick(scope.row)"
                  >
                    {{ scope.row[item.key] }}
                  </span>
                  <span
                    v-if="item.label !== '变更次数'"
                    :title="scope.row[item.key]"
                  >
                    {{ scope.row[item.key] }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="200px">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.zt != '00'"
                    v-preventReClick
                    type="primary"
                    icon="el-icon-document"
                    size="mini"
                    @click="query(scope.row)"
                  >查看</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    v-preventReClick
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    @click="edit(scope.row)"
                  >编辑</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    v-preventReClick
                    type="primary"
                    class="deleteButton"
                    icon="el-icon-delete"
                    size="mini"
                    @click="Delete(scope.row.id)"
                  >删除</el-button>
                  <el-button
                    v-if="scope.row.zt != '00'"
                    v-preventReClick
                    :type="scope.row.zt == '11' ? 'info' : 'warning'"
                    :disabled="scope.row.zt == '11'"
                    icon="el-icon-edit"
                    size="mini"
                    @click="biangeng(scope.row)"
                  >变更</el-button>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :page-sizes="[10, 20, 30, 40]"
            :total="total"
            :page-size="pagesize"
            class="el-page"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <bgcs
      :bgwindow="bgwindow"
      :bgcs-t-k-name="bgcsTKName"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    />
    <cangchu-rk-pup
      ref="changchuRk"
      :bgdisable="bgdisable"
      :djsjshow="djsjshow"
      :t-y-p-e="type"
    />
  </div>
</template>
<script>
import CangchuRkPup from './cangchuRkPup.vue'
import {
  rukuPage,
  getZT,
  rukuDraft,
  excelwriter
} from '@/assets/js/ccgl'
import bgcs from '@/components/bgcs'
import {getListCkcx} from '@/assets/js/common.js'
export default {
  components: { CangchuRkPup, bgcs },
  props: {},
  data() {
    return {
      bgcsTKName: '仓储入库',
      bgwindow: false, // 变更次数弹窗
      // 登记时间隐藏
      djsjshow: false,
      // 变更不可编辑
      bgdisable: false,
      loading: true,
      ztList: [],
      ckList: [],
      type: '',
      pupopShow: false,
      searchForm: {
        hxpMc: '',
        zt: '',
        ckId: '',
        beginTime: '',
        endTime: ''
      },
      table: [
        {
          key: 'rkbh',
          label: '入库编号'
        },
        {
          key: 'wtDwMc',
          label: '委托单位'
        },
        {
          key: 'hxpMc',
          label: '化学品名称'
        },
        {
          key: 'ckMc',
          label: '仓库名称'
        },
        {
          key: 'rkslStr',
          label: '入库数量'
        },
        {
          key: 'rkrq',
          label: '入库日期'
        },
        {
          key: 'djr',
          label: '登记人'
        },

        {
          key: 'djsj',
          label: '登记时间'
        },
        {
          key: 'bgcs',
          label: '变更次数'
        },
        {
          key: 'ztStr',
          label: '状态'
        }
      ],
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10 // 每页的数据条数
    }
  },
  computed: {},
  watch: {},
  created() {
    this.info()
    // 获取仓库
    getListCkcx().then((e) => {
      this.ckList = e.data.data
    })
    getZT().then((e) => {
      this.ztList = e.data.data
    })
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    // 点击变更次数
    bgcsClick(curRow) {
      this.curRowObj = curRow
      this.$bus.emit('bgcsOpen', curRow, '12')
      this.bgwindow =
        curRow.bgcs > 0 ? (this.bgwindow = !this.bgwindow) : false
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    hchange(data) {
      console.log(data)
    },
    select(selection, row) {
      this.$refs.ccrkTable.clearSelection()
      if (selection.length === 0) {
        // 判断selection是否有值存在
        return
      }
      if (row) {
        this.$refs.ccrkTable.toggleRowSelection(row, true)
      }
    },
    // 打开添加弹窗
    addPupShow() {
      this.djsjshow = false
      this.bgdisable = false
      this.type = 'add'
      // 调用弹窗组件内方法添加
      this.$refs.changchuRk.add()
      this.$refs.changchuRk.biangengShow = false
      setTimeout(() => {
        this.$refs.changchuRk.initCon({}, 12)
      }, 30)
    },
    // 复制新增
    fuzhi() {
      this.djsjshow = false
      this.bgdisable = false
      this.$refs.changchuRk.biangengShow = false
      const row =
        this.$refs.ccrkTable.selection.length != 0
          ? this.$refs.ccrkTable.selection[0]
          : null
      if (row) {
        this.type = 'add'
        this.$refs.changchuRk.fuzhi(row)
        setTimeout(() => {
          this.$refs.changchuRk.initCon({}, 12)
        }, 30)
      } else {
        this.$message.error('请选择要复制新增的内容')
      }
    },
    // 条件搜索
    sousuo() {
      this.info()
    },
    // 导出
    daochu() {
      excelwriter({
        param: this.searchForm,
        page: this.currentPage,
        size: this.pagesize
      }).then((e) => {
        const table = '仓储入库'
        const a = document.createElement('a')
        const blob = new Blob([e.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    // 重置搜索条件
    chongzhi() {
      this.searchForm = {
        hxpMc: '',
        zt: '',
        ckId: '',
        beginTime: '',
        endTime: ''
      }
      this.info()
    },
    // 修改
    edit(row) {
      this.djsjshow = true
      this.bgdisable = false
      this.type = 'edit'
      this.$refs.changchuRk.edit(row)
      this.$refs.changchuRk.biangengShow = false
      setTimeout(() => {
        this.$refs.changchuRk.initCon(row, 12)
      }, 30)
    },
    // 删除
    Delete(id) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          rukuDraft(id).then(() => {
            this.info()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 查看
    query(row) {
      this.type = 'query'
      this.djsjshow = true
      this.$refs.changchuRk.query(row)
      this.bgdisable = false
      this.$refs.changchuRk.biangengShow = false
      setTimeout(() => {
        this.$refs.changchuRk.initCon(row, 12)
      }, 30)
    },
    // 变更
    biangeng(row) {
      this.djsjshow = true
      this.bgdisable = true
      this.type = 'biangeng'
      this.$refs.changchuRk.biangeng(row)
      this.$refs.changchuRk.biangengShow = true

      setTimeout(() => {
        this.$refs.changchuRk.initCon(row, 12)
      }, 30)
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (columnIndex == 9) {
        switch (row.zt) {
          case '01':
            cellStyle = 'color:#6FC89A;font-weight:bold '
            break
          case '11':
            cellStyle = 'color:#43A5E2;font-weight:bold '
            break
          case '00':
            cellStyle = 'color:#000;font-weight:bold '
            break
          default:
            cellStyle = ''
            break
        }
        return cellStyle
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.info()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.info()
    },
    info() {
      rukuPage({
        param: this.searchForm,
        page: this.currentPage,
        size: this.pagesize
      })
        .then((e) => {
          this.total = e.data.data.total
          this.loading = false
          this.tableData = e.data.data.rows
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style scoped lang='less'>
.el-table--border {
  z-index: 0;
}
.resetbutton {
  width: 90px;
  height: 39px;
  border-radius: 20px;
}
.cangchu_rk {
  // height: 100%;
  // width: 90%;
  // background-color: white;
  // margin: auto;
  .headerSearch {
    max-width: 1518px;
    width: 95%;
    margin: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        width: 90px;
        height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-color: #4170ff;
    }
    .chongzhiButton {
      width: 90px;
      height: 39px;
    }
  }
  .tablemes {
    margin: auto;
    width: 90%;
    max-width: 1375px;
    // margin-top: 21px;
    // margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    // .addButton {
    //   color: #fff;
    //   background: #4170ff;
    //   border-radius: 3px;
    //   border-color: #4170ff;
    // }
    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }
    .el-button--warning {
      color: #fff;
      background: #feb800;
      border-radius: 3px;
      border-color: #feb800;
    }
    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/ .has-gutter {
  .el-checkbox {
    display: none;
  }
}
/deep/.el-table-column--selection .cell {
  padding-left: 10px;
  padding-right: 10px;
}
</style>
